import { createContext } from "react";
import { BadgeList } from "../utils/types";

export const BadgesContext = createContext<BadgeList | null>(null);